// functions to extract fields and data for `Grid` table
import { html } from 'gridjs';

function getFields(fieldName: string[]) {
    let tmpFields = [];

    fieldName.forEach((element) => {
        const obj = {
            name: element,
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`)
        }
        tmpFields.push(obj)
    });

    return tmpFields;
}


function getDataList(data: any[]) {
    let dataArr = []

    data.forEach((item) => {
        let itemValues = Object.values(item)
        itemValues.push(item.id)
        dataArr.push(itemValues);
    });

    return dataArr;
}

export { getFields, getDataList }